import React from 'react';
import PropTypes from 'prop-types';
import {
  Route,
  Redirect,
} from 'react-router-dom';

import useAuth from './hooks/useAuth';

const ProtectedRoute = ({
  children, adminOnly, mainOnly, ...rest
}) => {
  const { isLoggedIn, user } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!isLoggedIn) {
          return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
        }

        // Admin-side routes are shared by 'main' and 'typer'; only 'matcher' uses the matcher UI.
        if (adminOnly && user.type === 'matcher') {
          return <Redirect to={{ pathname: '/matcher/home', state: { from: location } }} />;
        }

        if (!adminOnly && user.type !== 'matcher') {
          return <Redirect to={{ pathname: '/admin/home', state: { from: location } }} />;
        }

        // Routes typers must not reach (matchers, secondary inspection).
        if (mainOnly && user.type !== 'main') {
          return <Redirect to={{ pathname: '/admin/home', state: { from: location } }} />;
        }

        return children;
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  adminOnly: PropTypes.bool,
  mainOnly: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  adminOnly: false,
  mainOnly: false,
};

export default ProtectedRoute;
